const p = (o, r, e = "__") => o ? `${o}${e}${r}` : void 0;
export {
  p as propagateTestid
};
